import { registerLegacySalvoLiteComponent } from '@eastsideco/salvo-ts';

class ScrollTo {
    constructor(theme, elem) {
        this._theme = theme;
        this._name = this.constructor.name;
        this._elem = elem;
        this._topNav = document.querySelector('.header');
        this._mobileNav = document.querySelector('.mobile_nav');
    }

    onInit() {


        // Listen for clciks
        this._elem.addEventListener('click', () => {
            // Get height of header
            let headerHeight = this._topNav.offsetHeight;
            let mobileHeaderHeight = this._mobileNav.offsetHeight;
            let linkedElementValue = String(this._elem.dataset.scrollTo);
            let scrollElem = document.querySelector(linkedElementValue);
            // Get top pos of linked span
            let linkPos = scrollElem.getBoundingClientRect().top + window.scrollY - headerHeight - mobileHeaderHeight;

            // Load more
            this.scroll(linkPos);
        });
    }

    scroll(linkPos) {
        window.scrollTo(0, linkPos);
    }

}

export default registerLegacySalvoLiteComponent({
    component: ScrollTo,
    selector: '[data-scroll-to]', // Required
});
